module.exports = __webpack_public_path__ + "img/223.problem_sink_blockage.7967c6a8.svg";